import HeaderResume from '../header-resume/index.vue';
import TableLastMovements from '../table-last-movements/index.vue';
import TableOperationsMismatch from '../table-operations-mismatch/index.vue';
import TableProductsAvailable from '../table-products-available/index.vue';
import ModalWarningAction from '../modal-warning-action/index.vue';

const components = {
    HeaderResume,
    TableLastMovements,
    TableOperationsMismatch,
    TableProductsAvailable,
    ModalWarningAction
};

export default components;
